export default __webpack_public_path__ + "static/media/white-email-icon-25.d838f0a8.jpg";